import { RouterModule } from '@angular/router'
import { CmsConfig, provideConfig } from '@spartacus/core'
import { CarouselModule, MediaModule } from '@spartacus/storefront'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { MbI18nModule } from '../../../translations/mb-i18n.module'
import { CmsDirectivesModule } from '../../../cms/directives/cms-directives.module'
import { RelatedProductsComponent } from './related-products.component'
import { AnalyticsModule } from '../../../analytics/analytics.module'
import { SafeHtmlModule } from '../../../cms/pipes/sanitize-html/safe-html.module'
import {ProductsTeaserModule} from '../products-teaser/products-teaser.module';

@NgModule({
  providers: [
    provideConfig({
      cmsComponents: {
        ProductReferencesComponent: {
          component: RelatedProductsComponent
        },
      }
    } as CmsConfig),
  ],
  declarations: [RelatedProductsComponent],
  imports: [
    CommonModule,
    ProductsTeaserModule,
  ],
  exports: [RelatedProductsComponent]
})
export class RelatedProductsModule { }
